import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isFirebaseAuthConfigured } from '../firebase';
import { sendFirebasePasswordResetEmail } from '../services/firebasePassword';
import Navbar from '../components/Navbar';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
    setInfo('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFirebaseAuthConfigured) {
      setError('Configuration Firebase manquante : vérifiez REACT_APP_FIREBASE_* au build.');
      return;
    }
    setLoading(true);
    setError('');
    setInfo('');
    const result = await login(formData.email, formData.password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Impossible de vous connecter.');
    }
    setLoading(false);
  };

  const handleForgotPassword = async () => {
    setError('');
    setInfo('');
    if (!isFirebaseAuthConfigured) {
      setError('Firebase Auth n’est pas configuré.');
      return;
    }
    if (!formData.email.trim()) {
      setError('Saisissez votre email ci-dessus, puis cliquez à nouveau sur « Mot de passe oublié ».');
      return;
    }
    setResetLoading(true);
    const result = await sendFirebasePasswordResetEmail(formData.email);
    setResetLoading(false);
    if (result.success) {
      setInfo(
        'Si un compte Maxfly est associé à cet email, vous recevrez un message Firebase avec un lien sécurisé. Vérifiez vos courriers indésirables.'
      );
    } else {
      setError(result.error || 'Envoi impossible.');
    }
  };

  return (
    <div>
      <Navbar />

      <div className="container">
        <div className="auth-container">
          <div className="auth-card">
            <h1 className="auth-title">Connexion</h1>


            {!isFirebaseAuthConfigured && (
              <div className="auth-error">
                Firebase Auth n’est pas configuré sur cette application.
              </div>
            )}

            {error && <div className="auth-error">{error}</div>}
            {info && (
              <div
                className="auth-error"
                style={{
                  backgroundColor: '#e8f5e9',
                  borderColor: '#a5d6a7',
                  color: '#1b5e20',
                }}
              >
                {info}
              </div>
            )}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="votre@email.com"
                  required
                  autoComplete="email"
                  disabled={!isFirebaseAuthConfigured}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Mot de passe</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                  disabled={!isFirebaseAuthConfigured}
                />
                <button
                  type="button"
                  className="auth-link"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '8px 0 0',
                    cursor: 'pointer',
                    fontSize: '14px',
                    textDecoration: 'underline',
                    color: '#c62828',
                  }}
                  disabled={!isFirebaseAuthConfigured || resetLoading || loading}
                  onClick={handleForgotPassword}
                >
                  {resetLoading ? 'Envoi en cours…' : 'Mot de passe oublié ?'}
                </button>
              </div>

              <button
                type="submit"
                className="btn btn-primary auth-submit"
                disabled={loading || !isFirebaseAuthConfigured}
              >
                {loading ? 'Connexion…' : 'Se connecter'}
              </button>
            </form>

            <div className="auth-footer">
              <p>
                Pas encore de compte ?{' '}
                <Link to="/register" className="auth-link">
                  Créer un compte
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
